import axios from "axios";
import { resolveApiUrl } from "../assets/GlobalVariables";
import { getSessionId } from "./authService";

const MORNING_RETURN_LOG_PATH = "/api/subscription/morning-return-log";

/**
 * שומר את כל query params מ-Morning — ללא הפעלת מנוי/כיסוי.
 * @param {{ packageCode?: string|null, queryParams: Record<string, string>, rawQueryString?: string }} payload
 */
export async function postMorningSubscriptionReturnLog(payload) {
  const headers = { "Content-Type": "application/json" };
  try {
    const sessionID = await getSessionId();
    if (sessionID) {
      headers["X-Session-ID"] = String(sessionID).trim();
    }
  } catch {
    /* optional session */
  }

  const { data } = await axios.post(resolveApiUrl(MORNING_RETURN_LOG_PATH), payload, {
    headers,
    withCredentials: true,
    timeout: 15000,
  });
  return data;
}
